export const TOTAL_STEPS = 23;

export const steps = [
  // Step 1: Gender (SingleSelect)
  {
    type: "singleSelect",
    field: "gender",
    title: "What's your gender?",
    subtitle: "This helps us personalize your wellness journey",
    options: [
      { value: "female", label: "Female" },
      { value: "male", label: "Male" },
    ],
  },

  // Step 2: Goals (MultiSelect)
  {
    type: "multiselect",
    field: "goals",
    title: "What are your goals?",
    subtitle: "Let's define your journey ahead!",
    options: [
      { value: "weight_loss", label: "Losing weight" },
      { value: "overall_health", label: "Improving my overall health" },
      { value: "gut_health", label: "Improving my gut health" },
    ],
  },

  // Step 3: Veggies (SingleSelect)
  {
    type: "singleSelect",
    field: "veggies",
    title: "How often do you eat veggies?",
    subtitle: "Raw, cooked, or crunchy, how green is your routine?",
    options: [
      { value: "never", label: "Never" },
      { value: "sometimes", label: "Sometimes" },
      { value: "often", label: "Often" },
      { value: "daily", label: "Every day" },
    ],
  },

  // Step 4: Fermented Foods (SingleSelect)
  {
    type: "singleSelect",
    field: "fermented",
    title: "How often do you eat fermented foods?",
    subtitle: "Think yogurt, pickles, sauerkraut, or miso gut goodness!",
    options: [
      { value: "never", label: "Never" },
      { value: "sometimes", label: "Sometimes" },
      { value: "often", label: "Often" },
      { value: "daily", label: "Every day" },
    ],
  },

  // Step 5: Weight Gain (SingleSelect)
  {
    type: "singleSelect",
    field: "weight_gain",
    title: "Have you gained weight in the last year?",
    subtitle: "Please select one",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },

  // Step 6: Diets (MultiSelect)
  {
    type: "multiselect",
    field: "diets",
    title: "What diets have you tried in the last year?",
    subtitle: "Please select all that apply",
    options: [
      { value: "keto", label: "Keto" },
      { value: "fasting", label: "Fasting" },
      { value: "paleo", label: "Paleo" },
      { value: "mediterranean", label: "Mediterranean" },
      { value: "vegetarian", label: "Vegetarian or Vegan diet" },
      { value: "none", label: "None of the above", exclusive: true },
    ],
  },

  // Step 7: Symptoms (MultiSelect)
  {
    type: "multiselect",
    field: "symptoms",
    title: "Do you experience any of these symptoms?",
    subtitle: "Please select all that apply",
    options: [
      { value: "bloating", label: "Bloating and gas" },
      { value: "cramps", label: "Cramps and abdominal pain" },
      { value: "diarrhea", label: "Diarrhea" },
      { value: "constipation", label: "Constipation" },
      { value: "heartburn", label: "Heartburn or acid reflux" },
      { value: "nausea", label: "Nausea" },
      { value: "fatigue", label: "Fatigue or low energy" },
      { value: "none", label: "None of the above", exclusive: true },
    ],
  },

  // Step 8: Struggles (MultiSelect)
  {
    type: "multiselect",
    field: "struggles",
    title: "Do you struggle with any of these issues?",
    subtitle: "Please select all that apply",
    options: [
      { value: "weight_bouncing", label: "Weight bouncing back" },
      { value: "hunger_cravings", label: "Hunger and cravings" },
      { value: "low_energy", label: "Low energy" },
      { value: "none", label: "None of the above", exclusive: true },
    ],
  },

  // Step 9: Eating Habits (MultiSelect)
  {
    type: "multiselect",
    field: "eating_habits",
    title: "Do you sometimes tend to...",
    subtitle: "Please select all that apply",
    options: [
      { value: "overeat", label: "Overeat" },
      { value: "stress_eat", label: "Stress eat" },
      { value: "eat_irregularly", label: "Eat irregularly" },
      { value: "fast_food", label: "Eat fast food" },
      { value: "none", label: "None of the above", exclusive: true },
    ],
  },

  // Step 10: Info (Product Intro)
  {
    type: "info",
    title: "We got you!",
    subtitle:
      "Boosting your unique gut flora is the key to solving your digestive issues",
    content: "productIntro",
  },

  // Step 11: Age Form
  {
    type: "form",
    field: "age",
    formType: "age",
    title: "What's your age?",
    subtitle: "Tell us your age so we can tailor your results",
  },

  // Step 12: Height Form
  {
    type: "form",
    field: "height",
    formType: "height",
    title: "What's your height?",
    subtitle: "Your height helps us fine-tune your plan",
  },

  // Step 13: Weight Form
  {
    type: "form",
    field: "weight",
    formType: "weight",
    title: "Your weight details",
    subtitle: "Tell us where you are and where you want to be",
  },

  // Step 14: Loading
  {
    type: "loading",
    title: "Determining your bacteria balance...",
    subtitle: "Analyzing your responses to create your personalized plan",
  },

  // Step 15: Email Form
  {
    type: "form",
    field: "email",
    formType: "email",
    title: "Get your personalized results",
    subtitle:
      "Enter your email to receive your custom gut health recommendations",
    buttonText: "Unlock my results",
  },

  // Step 16: Summary - Bacteria Overgrowth
  {
    type: "summary",
    content: "bacteriaOvergrowth",
  },

  // Step 17: Summary - Bacteria Balance
  {
    type: "summary",
    content: "bacteriaBalance",
  },

  // Step 18: Summary - Personal Summary
  {
    type: "summary",
    content: "personalSummary",
  },

  // Step 19: Summary - Gut & Weight Loss
  {
    type: "summary",
    content: "gutWeightLoss",
  },

  // Step 20: Summary - Product Benefits
  {
    type: "summary",
    content: "productBenefits",
  },

  // Step 21: Summary - How Quickly
  {
    type: "summary",
    content: "howQuickly",
  },

  // Step 22: Summary - Before/After Testimonial
  {
    type: "summary",
    content: "testimonialSingle",
  },

  // Step 23: Summary - Multiple Testimonials
  {
    type: "summary",
    content: "testimonialMultiple",
  },
];
